const initialState = {
   videos: {},
   errors: {},
   isFetchingData: true,
   isFetchingDataByFilter: false,
};

export default initialState;
